import React from 'react'
import { courseMutations } from '../../graphql/mutations/'
import { useMutation } from '@apollo/react-hooks'
import * as courseUtils from '../../utils/course'
import { useHistory } from 'react-router-dom'
import { GET_COURSE_PROGRESS, GET_COURSE } from '../../graphql/queries/courses'
import QuizStructure from '../quizGeneralComponents/QuizStructure'

const Quiz = ({ content, courseId, id, trails,conteudo_id,presentation }) => {
  const history = useHistory()
  const updateCache = (cache, { data }) => {
    const { conteudo_id, progresso } = (data || {}).adicionaProgresso
    const queryGET_COURSE_PROGRESS = {
      query: GET_COURSE_PROGRESS,
      variables: {
        curso_id: courseId
      }
    }

    const queryGET_COURSE = {
      query: GET_COURSE,
      variables: {
        id: courseId
      }
    }

    const currentCourseProgress = cache.readQuery(queryGET_COURSE_PROGRESS)
    const currentCourseData = cache.readQuery(queryGET_COURSE)

    const conteudos_concluidos = [
      ...(((currentCourseProgress || {}).progressoCurso || {}).conteudos_concluidos || []).filter(id => id !== conteudo_id)
    ]

    if ((currentCourseData || {}).curso) {
      cache.writeQuery({
        ...queryGET_COURSE,
        data: {
          ...currentCourseData,
          curso: {
            ...currentCourseData.curso,
            progresso
          }
        }
      })
    }

    if (!(currentCourseProgress || {}).progressoCurso) {
      cache.writeQuery({
        ...queryGET_COURSE_PROGRESS,
        data: {
          progressoCurso: {
            __typename: 'ProgressoCurso',
            _id: '95873493485734958734987',
            conteudos_concluidos: [conteudo_id]
          }
        }
      })
    }

    cache.writeQuery({
      ...queryGET_COURSE_PROGRESS,
      data: {
        ...currentCourseProgress,
        progressoCurso: {
          ...currentCourseProgress.progressoCurso,
          conteudos_concluidos: [conteudo_id, ...conteudos_concluidos]
        }
      }
    })
  }

  const [adicionaProgresso] = useMutation(courseMutations.ADD_PROGRESS, {
    update: updateCache
  })

  let contents = null
  let nextContent = null

  if ((trails || {}).length) {
    contents = courseUtils.getContentsFromTrails(trails)
  }

  if (contents) {
    nextContent = (contents[courseUtils.getNextContentIdFromContents(contents)(id)] || {})._id
  }

  const handleNextContent = () => {
    id &&
      courseId &&
      adicionaProgresso({
        variables: {
          conteudoId: id,
          cursoId: courseId
        }
      })
    history.push(nextContent)
  }

  return (
    <>
      <QuizStructure
        content={content}      
        type="quiz"
        presentation={presentation}
        id={id}
        courseId={courseId}
        nextContent={nextContent}
        handleNextContent={handleNextContent}
      />
    </>
  )
}

export default Quiz
